export default {"src":"/_next/static/media/icon_timeline.5ada1d61.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};